import Device from "baseStyles/enums/device";
import { SuiStylesType, useSuiStyles } from "baseStyles/useSuiStyles";
import { FlexBoxPropsType } from "schoolUiComponents/basic/Box/FlexBox/types";

type PropsType = {}

type StylesType = {
    mainBox: FlexBoxPropsType;
    childBox: FlexBoxPropsType;
    orBox: FlexBoxPropsType;
    newChild: FlexBoxPropsType;
    childWithImage: FlexBoxPropsType;
    childWithoutImage: FlexBoxPropsType;
    successPopup: FlexBoxPropsType;
    successPopupWrap: FlexBoxPropsType;
}

const Styles: SuiStylesType<PropsType, StylesType> = {
    [Device.types.Desktop]: ({theme}) => {
        return {
            mainBox: {
                width: '100%',
            },
            childBox: {
            },
            orBox: {
                margin: "180px 0 0 0",
            },
            newChild: {
                width: 440,
            },
            replaceChild: {
                width: 327,
            },
            childWithImage: {
                width: 165
            },
            childWithoutImage: {
                width: 165
            },
            successPopupWrap: {
                padding: 32,
            },
            successPopup: {
                width: 552,
            }
        }
    },
    [Device.types.Tablet]: (props) => {
        return {
            mainBox: {
                width: "100%"
            },
            childBox: {
            },
            orBox: {
                margin: "180px 0 0 0",
            },
            newChild: {
                width: 400,
            },
            replaceChild: {
                width: 400,
            },
            childWithImage: {
                width: 156
            },
            childWithoutImage: {
                width: 156
            },
            successPopupWrap: {
                padding: 24,
            },
            successPopup : {
                width: 320,
            }
        }
    },
    [Device.types.Mobile]: (props) => {
        return {
            mainBox: {
                width: 327,
            },
            childBox: {
                column: true
            },
            orBox: {
                margin: "0 auto",
            },
            newChild: {
                width: 327,
            },
            replaceChild: {
                width: 327,
            },
            childWithImage: {
                width: 121
            },
            childWithoutImage: {
                width: 121
            }, 
            successPopupWrap: {
                padding: 20,
            },
            successPopup: {
                width: 303,
            }
        }
    }
}

const MergeStudentStyles = useSuiStyles(Styles);

export default MergeStudentStyles;